export const siteMeta = {
  name: "诱惑吃瓜",
  slogan: "实锤证据 · 反转辟谣 · 真相全复盘",
  description:
    "诱惑吃瓜专注娱乐事件的完整复盘，用时间线和证据链把来龙去脉捋清楚，标注实锤、反转、辟谣与待跟进四种结论，帮你看清瓜田背后的真实故事。",
  keywords: "诱惑吃瓜,诱惑吃瓜实锤,诱惑吃瓜反转,诱惑吃瓜辟谣,诱惑吃瓜揭底,诱惑吃瓜证据,诱惑吃瓜来龙去脉",
  email: "hello@youhuochigua.com",
  sloganShort: "把每个瓜的来龙去脉捋清楚",
};

export const siteNav = [
  { label: "首页", path: "/" },
  { label: "事件复盘", path: "/topics" },
  { label: "关于我们", path: "/about" },
  { label: "常见问题", path: "/faq" },
  { label: "联系我们", path: "/contact" },
];

export const categories = [
  { key: "全部", label: "全部", desc: "所有已整理的事件复盘", icon: "ri-stack-line" },
  { key: "音乐", label: "音乐", desc: "合约、版权与作品争议", icon: "ri-music-2-line" },
  { key: "综艺", label: "综艺", desc: "剪辑、赛制与现场还原", icon: "ri-live-line" },
  { key: "影视", label: "影视", desc: "选角、通告与片场风波", icon: "ri-film-line" },
  { key: "网红直播", label: "网红直播", desc: "带货、售后与数据核实", icon: "ri-live-fill" },
  { key: "商业合约", label: "商业合约", desc: "联名、代言与口径核对", icon: "ri-briefcase-line" },
];

export const statusStyles: Record<string, { label: string; className: string }> = {
  实锤: { label: "实锤", className: "bg-primary-500 text-background-50" },
  反转: { label: "反转", className: "bg-accent-500 text-foreground-950" },
  辟谣: { label: "辟谣", className: "bg-secondary-500 text-background-50" },
  待跟进: { label: "待跟进", className: "bg-foreground-700 text-background-50" },
};

export const siteStats = [
  { value: "1,280+", label: "已复盘事件" },
  { value: "5,600+", label: "核查证据点" },
  { value: "326", label: "反转与辟谣" },
  { value: "48 小时", label: "热点跟进时效" },
];

export const tickerItems = [
  "合约纠纷事件补充第三份录音棚材料，时间线再度更新",
  "综艺剪辑争议完整版素材释出，被删片段还原完成",
  "换角传闻当事通告出处已核实，系旧文件二次传播",
  "联名款销量口径说明发布，平台数据与品牌口径差异明确",
  "采样版权三方沟通记录整理完毕，结论待双方确认",
  "直播退货第三方质检报告全文上线，关键指标可复核",
];

export const brandValues = [
  {
    icon: "ri-time-line",
    title: "先时间线，后结论",
    desc: "任何事件都先按时间顺序把发生过的事排好，再谈谁对谁错，避免情绪先于事实。",
  },
  {
    icon: "ri-file-search-line",
    title: "证据可回溯",
    desc: "每条结论都标注它来自哪类材料，截图、录音、通告还是公开回应，全部可回溯核对。",
  },
  {
    icon: "ri-scales-3-line",
    title: "双方说法并列",
    desc: "当事各方说法并列呈现，不做选择性引用，把分歧点单独标出来讲清楚。",
  },
  {
    icon: "ri-refresh-line",
    title: "错了就改",
    desc: "如果后续出现新证据推翻了我们的判断，会在原文标注修订时间与修订原因。",
  },
];

export const testimonials = [
  {
    name: "陆一鸣",
    role: "三年老读者",
    text: "别的地方刷半天还是一头雾水，这里直接给时间线，谁什么时候做了什么一目了然，省了我好多时间。",
  },
  {
    name: "苏晓白",
    role: "内容从业者",
    text: "证据清单这个设计太实用了，每一条都写清楚出处。做选题调研的时候我基本都先来这里过一遍。",
  },
  {
    name: "郑向北",
    role: "吃瓜群众",
    text: "最服的是错了会改。之前一个事件他们标了实锤，后来出了新料，原文直接打了修订说明，这种态度很难得。",
  },
  {
    name: "何嘉树",
    role: "高校学生",
    text: "写论文做媒介素养案例的时候参考过这里的反转案例，中立、克制，不煽动情绪，很适合当分析样本。",
  },
];

export const generalFaqs = [
  {
    q: "「诱惑吃瓜」的内容是怎么整理出来的？",
    a: "我们只基于公开可查的材料进行整理，包括公开回应、官方通告、节目正片、平台数据页面等。所有材料会按时间顺序排列成时间线，再归纳成证据清单，最后给出结论倾向。",
  },
  {
    q: "「实锤」「反转」「辟谣」「待跟进」分别是什么意思？",
    a: "实锤指关键事实有可直接验证的材料支撑；反转指后续新信息推翻了此前的普遍说法；辟谣指传言经核对后不成立；待跟进表示当前材料不足以定论，我们会持续更新。",
  },
  {
    q: "发现内容有误或者有新的材料，可以怎么反馈？",
    a: "可以通过「联系我们」页面留言，附上材料来源线索即可。我们会核对后更新原文，并在文末标注修订记录与修订时间。",
  },
  {
    q: "为什么有些事件迟迟不给结论？",
    a: "当双方说法冲突、且缺少可验证的第三方材料时，我们会把它标注为「待跟进」而不是强行下判断。宁可晚一点，也不愿意给出经不起复核的结论。",
  },
  {
    q: "网站会收录涉及未成年人或私人隐私的内容吗？",
    a: "不会。涉及未成年人、非公众人物的私人生活、以及无法核实来源的爆料，我们一律不整理、不展示。",
  },
  {
    q: "阅读这些复盘需要付费吗？",
    a: "全部内容免费阅读，不需要注册登录，也没有付费墙。我们希望信息梳理这件事本身越容易获得越好。",
  },
];